<template>
  <div style="padding: 1em;">
    <ckeditor v-model="newDescription" @change="changeValue()" :config="{}"></ckeditor>

    <v-btn style="margin: 0" v-if="newDescription !== description" @click="onSave()"> Αποθήκευση </v-btn>
  </div>
</template>

<script>
  export default {
    name: "DescriptionEditor",
    data: () => ({
      newDescription: null,
      hasChanged: false,

    }),
    props: {description:String},
    mounted(){
      this.newDescription = this.description;
    },
    methods: {
      changeValue() {
        this.hasChanged = true
      },
      onSave(){
        this.hasChanged = false;
        if(this.newDescription === ""){
          this.$emit('onSave'," - ")

        }else{
          this.$emit('onSave',this.newDescription)

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DescriptionEditor.vue